module.exports = __webpack_public_path__ + "img/Cover_FS_26.eb3575ea.jpg";